import script from "./NavigationButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./NavigationButton.vue?vue&type=script&lang=ts&setup=true"

import "./NavigationButton.vue?vue&type=style&index=0&id=1c99c591&scoped=true&lang=scss"

import exportComponent from "/var/icar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c99c591"]])

export default __exports__